// extracted by mini-css-extract-plugin
module.exports = {"toastMessage":"invite-member_toastMessage__3EN9x","title":"invite-member_title__1UKeb","desc":"invite-member_desc__BepGz"};